import React from 'react';
import MinimalLayout from "../../layouts/minimal";
import {useRouteError} from "react-router-dom";

export default function BaseError () {
  let error = useRouteError();

  console.log(error);
  return (
    <div className={"container vh-100 d-flex align-items-center"}>
      <div className={"col align-items-center align-content-center"}>
        <h1 className="py-8">Nastala chyba :(</h1>
        <p className="text-grey-dark">
          {error.message}
        </p>
        <p className="text-grey-dark col">
          <pre>{error.stack}</pre>
        </p>
      </div>
    </div>
  );
}

BaseError.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

BaseError.getSEO = function getSEO() {
  return {
    title: "404 - Stránka neexistuje",
  }
}
